/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Row from './Row';
import styles from './simpletable.scss';

const stClassName = styles.stClassName.replace(/"/g, '');

export default class THead extends Component {
	static propTypes = {
		headerRenderer: PropTypes.func,
		colLength: PropTypes.number,
		widthDivision: PropTypes.object,
	};
	render() {
		return (
			<thead className={`${stClassName}-thead`}>
				<Row
					className={`${stClassName}-thead-row`}
					widthDivision={this.props.widthDivision}
					colLength={this.props.colLength}
					headerRenderer={this.props.headerRenderer}
					headerRow
				/>
			</thead>
		);
	}
}
